import { atom } from 'jotai'

/**
 * Atom representing the current page of the warrant grid.
 */
export const warrantGridCurrentPageAtom = atom(0)

/**
 * Atom representing the active tab in the warrant section.
 */
export const warrantActiveTabAtom = atom('current')

/**
 * Atom representing the search text input in the warrant section.
 */
export const warrantSearchTextfieldAtom = atom('')

export const warrantFiltersAtom = atom({
    listed: { value: ['all'] },
    onlyInWatchLists: { value: false },
    inTheMoney: { value: ['all'] },
    sectors: { value: [] },
    marketplaces: {
        value: [],
    },
})
